import React from 'react';

// Identifications
export const IdentificationScreen = React.lazy(() => import('./screens/IdentificationScreen'));
export const IdentificationAPISScreen = React.lazy(() => import('./screens/IdentificationAPISScreen'));
export const IdentificationClientsScreen = React.lazy(() => import('./screens/IdentificationClientsScreen'));
export const IdentificationClientsDetailScreen = React.lazy(() => import('./screens/IdentificationClientsDetailScreen'));

export const IdentificationUsersScreen = React.lazy(() => import('./screens/IdentificationUsersScreen'));
export const IdentificationUserDetailScreen = React.lazy(() => import('./screens/IdentificationUserDetailScreen'));

//Company (customer) creation
export const CompanyRegistrationScreen = React.lazy(() => import('./screens/CompanyRegistrationScreen'));
export const CompanyAccountRegistrationScreen = React.lazy(() => import('./screens/CompanyAccountRegistrationScreen'));
export const CompanyBillingAddressRegistrationScreen = React.lazy(() => import('./screens/CompanyBillingAddressRegistrationScreen'));
export const CompanyAdminUserRegistrationScreen = React.lazy(() => import('./screens/CompanyAdminUserRegistrationScreen'));
export const CompanyRegistrationSummaryScreen = React.lazy(() => import('./screens/CompanyRegistrationSummaryScreen'));

// Company (customer) administration
export const CompaniesOverviewScreen = React.lazy(() => import('./screens/CompaniesOverviewScreen'));
/** @type {React.LazyExoticComponent<React.ComponentType<any>>} */
export const CompanyAdministrationScreen = React.lazy(() => import('./screens/CompanyAdministrationScreen'));
export const CustomerAdministrationAccountScreen = React.lazy(() => import('./screens/CustomerAdministrationAccountScreen'));
export const CustomerAdministrationAuditLogScreen = React.lazy(() => import('./screens/CustomerAdministrationAuditLogScreen'));
export const CustomerAdministrationLicensesScreen = React.lazy(() => import('./screens/CustomerAdministrationLicensesScreen'));
export const CustomerAdministrationApiKeysScreen = React.lazy(() => import('./screens/CustomerAdministrationApiKeysScreen'));

export const CustomerAdministrationAccessScreen = React.lazy(() => import('./screens/CustomerAdministrationAccessScreen'));
export const CustomerAdministrationFeatureFlagAccessScreen = React.lazy(() => import('./screens/CustomerAdministrationFeatureFlagAccessScreen'));

// Licenses administration
export const LicensesAdministrationScreen = React.lazy(() => import('./screens/LicensesAdministrationScreen'));
export const CustomerAdministrationUsersScreen = React.lazy(() => import('./screens/CustomerAdministrationUsersScreen'));

// Roles administration
export const RolesAdministrationScreen = React.lazy(() => import('./screens/RolesAdministrationScreen'));

//Subjects administration
export const SubjectAdministrationScreen = React.lazy(() => import('./screens/SubjectAdministrationScreen'));

// Stats
export const StatisticsScreen = React.lazy(() => import('./screens/StatisticsScreen'));

// Other
export const PayloadComparisonScreen = React.lazy(() => import('./screens/PayloadComparisonScreen'));

// Settings screen
export const SettingsScreen = React.lazy(() => import('./screens/SettingsScreen'));

// External users requests screen
export const ExternalUsersRequestsScreen = React.lazy(() => import('./screens/ExternalUsersRequestsScreen'));

//Feature flags administration
export const FeatureFlagsAdministrationScreen = React.lazy(() => import('./screens/FeatureFlagsAdministrationScreen'));

// Surveys
export const SurveysScreen = React.lazy(() => import('./screens/SurveysScreen'));
export const SurveyScreen = React.lazy(() => import('./screens/SurveyScreen'));

// Release notes
export const ReleaseNotesScreen = React.lazy(() => import('./screens/ReleaseNotesScreen'));

// Sentry test
export const TestSentryScreen = React.lazy(() => import('./screens/TestSentryScreen'));
